import { Controller } from "@hotwired/stimulus"

// Submits the controller's form whenever a control fires its change action.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
